import { render, staticRenderFns } from "./spring-contest.vue?vue&type=template&id=4fd99248&scoped=true&"
import script from "./spring-contest.vue?vue&type=script&lang=js&"
export * from "./spring-contest.vue?vue&type=script&lang=js&"
import style0 from "./spring-contest.vue?vue&type=style&index=0&id=4fd99248&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd99248",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Atlas: require('/var/jenkins_home/workspace/prod-web-xfans/components/atlas.vue').default})
